<template>
  <div class="listen-test-management">
    <section>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane label="详细课表" name="first">
          <el-form style="margin-top: 10px" :inline="true" size="mini">
            <el-form-item label="讲次名称">
              <el-input
                clearable
                style="width: 250px"
                v-model="teachplan_form.title"
                placeholder="请输入讲次名称"
              ></el-input>
            </el-form-item>

            <el-form-item>
              <el-button-group>
                <el-button type="primary" @click="search" icon="el-icon-search"
                  >查询
                </el-button>
                <el-button
                  type="primary"
                  @click="ChangeSearchState"
                  :icon="
                    moresearch ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
                  "
                ></el-button>
              </el-button-group>
            </el-form-item>

            <br />

            <el-form-item v-show="moresearch" label="班级名称">
              <el-input
                style="width: 200px"
                v-model="teachplan_form.classname"
                placeholder="请输入班级名称"
              ></el-input>
            </el-form-item>

            <el-form-item v-show="moresearch" label="上课老师">
              <el-select
                v-model="teachplan_form.lecturer_id"
                placeholder="请选择上课老师"
                clearable
              >
                <el-option
                  v-for="(item, index) of teacherList"
                  :key="index"
                  :label="item.realName + '(' + item.phoneNum + ')'"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="课程名称">
              <el-select
                v-model="teachplan_form.curriculum_id"
                placeholder="请选择课程名称"
                clearable
              >
                <el-option
                  v-for="(item, index) of course_list"
                  :key="index"
                  :label="item.title"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="星期">
              <el-select
                size="mini"
                v-model="teachplan_form.week"
                multiple
                collapse-tags
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in weeklist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="时段">
              <el-select
                size="mini"
                v-model="teachplan_form.time"
                multiple
                collapse-tags
                placeholder="请选择"
                clearable
              >
                <el-option
                  v-for="item in timelist"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item v-show="moresearch" label="上课时间">
              <el-date-picker
                v-model="teachplan_form.date"
                type="datetimerange"
                :picker-options="pickerOptions"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                align="right"
                value-format="yyyy-MM-dd HH:mm:ss"
                :default-time="['00:00:00', '23:59:59']"
                placement="bottom-start"
              >
              </el-date-picker>
            </el-form-item>

            <el-form-item v-show="moresearch" label="开课状态">
              <el-select
                size="mini"
                v-model="teachplan_form.sign_state"
                placeholder="请选择开课状态"
                clearable
              >
                <el-option label="全部" value=""></el-option>
                <el-option label="已上课" value="1"></el-option>
                <el-option label="未上课" value="2"></el-option>
              </el-select>
            </el-form-item>

            <el-tooltip
              class="item"
              effect="dark"
              content="最近课程: 是指今日及以后的教学计划"
              placement="top"
            >
              <el-checkbox
                v-model="teachplan_form.latest"
                style="float: right"
                @click.native="LatestCourse($event)"
                >最近课程</el-checkbox
              >
            </el-tooltip>
          </el-form>

          <div>
            <el-table
              size="mini"
              :data="TeachPlanList"
              :header-cell-style="{ background: '#f5f7fa' }"
            >
              <el-table-column fixed="left" label="讲次名称" width="150">
                <template slot-scope="scope">
                  <span
                    style="color: #409eff; cursor: pointer; font-weight: bold"
                    type="primary"
                    @click="UpdatePlanInfo(scope.row)"
                    >{{ scope.row.lessionInfo.title }}</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                prop="classInfo.name"
                label="所属班级"
                width="200"
              ></el-table-column>

              <el-table-column
                align="left"
                prop="classInfo.curriculumInfo.title"
                label="所属课程"
                width="200"
              ></el-table-column>

              <el-table-column
                align="center"
                prop="lecturerName"
                label="上课老师"
                width="150"
              ></el-table-column>

              <el-table-column align="center" label="星期" width="150">
                <template slot-scope="scope">
                  <span
                    v-if="
                      new Date(
                        scope.row.start_class_date.slice(0, 10)
                      ).getDay() == 0
                    "
                    >周日</span
                  >
                  <span
                    v-else-if="
                      new Date(
                        scope.row.start_class_date.slice(0, 10)
                      ).getDay() == 1
                    "
                    >周一</span
                  >
                  <span
                    v-else-if="
                      new Date(
                        scope.row.start_class_date.slice(0, 10)
                      ).getDay() == 2
                    "
                    >周二</span
                  >
                  <span
                    v-else-if="
                      new Date(
                        scope.row.start_class_date.slice(0, 10)
                      ).getDay() == 3
                    "
                    >周三</span
                  >
                  <span
                    v-else-if="
                      new Date(
                        scope.row.start_class_date.slice(0, 10)
                      ).getDay() == 4
                    "
                    >周四</span
                  >
                  <span
                    v-else-if="
                      new Date(
                        scope.row.start_class_date.slice(0, 10)
                      ).getDay() == 5
                    "
                    >周五</span
                  >
                  <span
                    v-else-if="
                      new Date(
                        scope.row.start_class_date.slice(0, 10)
                      ).getDay() == 6
                    "
                    >周六</span
                  >
                </template>
              </el-table-column>

              <el-table-column align="left" label="上课时间" width="200">
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.start_class_date }} -
                    {{ scope.row.end_class_date.slice(10, 20) }}</span
                  >
                </template>
              </el-table-column>

              <el-table-column
                align="left"
                prop="campusName"
                label="所属校区"
                width="200"
              ></el-table-column>

              <el-table-column align="center" width="100" label="实到/应到">
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.stuSignNum }} /
                    {{ scope.row.stuTotalSignNum }}</span
                  >
                </template>
              </el-table-column>

              <el-table-column align="center" label="类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.classInfo.curriculum_class_type == 1">
                    <span v-if="!scope.row.supplement_original_tch_plan_id">
                      常规
                    </span>
                    <span v-else>补课</span>
                  </span>
                  <span
                    v-else-if="scope.row.classInfo.curriculum_class_type == 2"
                    >试听</span
                  >
                </template>
              </el-table-column>

              <el-table-column align="center" width="100" label="状态">
                <template slot-scope="scope">
                  <span style="color: green" v-if="scope.row.sign_state == '1'"
                    >已上课</span
                  >
                  <span v-else-if="scope.row.sign_state == '2'">未上课</span>
                </template>
              </el-table-column>

              <el-table-column
                fixed="right"
                align="center"
                label="操作"
                width="100"
              >
                <template slot-scope="scope">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      操作<i class="el-icon-arrow-down"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item @click.native="GoSign(scope.row)"
                        >点名签到</el-dropdown-item
                      >

                      <el-dropdown-item
                        @click.native="AddStudentToPlan(scope.row)"
                        >添加学员</el-dropdown-item
                      >

                      <el-dropdown-item
                        @click.native="StudentChangePlan(scope.row)"
                        >临时调课</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="pagination-style">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="page_no"
              :page-sizes="[10, 15, 20, 30, 40, 50, 100]"
              :page-size="10"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total"
            >
            </el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </section>

    <!--点名上课-->
    <el-dialog width="80%" title="点名上课" :visible.sync="dialogFormVisible2">
      <el-row>
        <el-col :span="8"
          ><div>
            <span>班级名称:</span>
            <span style="margin-left: 20px">{{
              SignClassInfo.classInfo.name
            }}</span>
          </div></el-col
        >
        <el-col :span="8">
          <div>
            <span>上课时间:</span>
            <span style="margin-left: 20px"
              >{{ SignClassInfo.start_class_date }} -
              {{ SignClassInfo.end_class_date.slice(10, 20) }}</span
            >
          </div></el-col
        >

        <el-col :span="8">
          <div>
            <el-checkbox
              v-model="allcost"
              style="float: right; margin-right: 0px"
              @click.native="SetAllCost($event)"
              >批量计费</el-checkbox
            >

            <el-checkbox
              v-model="allsign"
              style="float: right; margin-right: 20px"
              @click.native="SetAllSign($event)"
              >批量全勤</el-checkbox
            >
          </div>
        </el-col>
      </el-row>

      <div style="margin-top: 20px">
        <el-table
          ref="multipleTable"
          size="small"
          :data="SignStudents"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
          @selection-change="handleSelectionChange1"
        >
          >

          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column align="center" label="姓名" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.stu_tch_plan_type == '1'">{{
                scope.row.studentInfo.studentUserInfo.realname
              }}</span>
              <span v-else-if="scope.row.stu_tch_plan_type == '2'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(试听)</span></span
              >
              <span v-else-if="scope.row.stu_tch_plan_type == '3'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(调课)</span></span
              >
              <span v-else-if="scope.row.stu_tch_plan_type == '4'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(补课)</span></span
              >
              <span v-else-if="scope.row.stu_tch_plan_type == '5'"
                >{{ scope.row.studentInfo.studentUserInfo.realname
                }}<span style="color: #e6a23c">(临加)</span></span
              >
            </template>
          </el-table-column>

          <el-table-column
            align="center"
            prop="studentInfo.name"
            label="平台账号"
            width="150"
          ></el-table-column>

          <el-table-column align="center" label="出勤状态" width="110">
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="scope.row.sign_state"
                placeholder="请选择出勤状态"
                clearable
              >
                <el-option label="出勤" :value="1"></el-option>
                <el-option label="缺勤" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column align="center" label="计费状态" width="110">
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="scope.row.cost_state"
                placeholder="请选择计费状态"
                clearable
              >
                <el-option label="计费" :value="1"></el-option>
                <el-option label="不计费" :value="2"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column align="center" label="缺勤原因" width="110">
            <template slot-scope="scope">
              <el-select
                size="mini"
                v-model="scope.row.not_come_reason"
                placeholder="请选择"
                clearable
              >
                <el-option label="事假" :value="1"></el-option>
                <el-option label="病假" :value="2"></el-option>
                <el-option label="旷课" :value="3"></el-option>
              </el-select>
            </template>
          </el-table-column>

          <el-table-column align="center" label="备注" width="150">
            <template slot-scope="scope">
              <el-input
                clearable
                size="mini"
                type="text"
                v-model="scope.row.remark"
              ></el-input>
            </template>
          </el-table-column>

          <el-table-column align="center" label="微信通知" width="100">
            <template slot-scope="scope">
              <span v-if="scope.row.is_send_wx_message">已发送</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            label="通知时间"
            prop="send_wx_message_date"
          >
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            label="签到时间"
            prop="sign_date"
            fixed="right"
          >
          </el-table-column>

          <el-table-column
            align="center"
            label="操作"
            width="100"
            fixed="right"
          >
            <template slot-scope="scope">
              <el-popconfirm
                title="确定将该学员从本讲次移除吗?"
                @onConfirm="deleteStuOfTeachingPlan(scope.row.student_user_id)"
              >
                <i
                  slot="reference"
                  style="cursor: pointer"
                  class="el-icon-delete"
                ></i>
              </el-popconfirm>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-tooltip
          class="item"
          effect="dark"
          content="为缺勤的学员,单独生成一条补课计划。推荐补课场景使用此操作，方便准确的统计业绩。"
          placement="top"
          v-if="
            !SignClassInfo.supplement_original_tch_plan_id &&
              SignClassInfo.classInfo.curriculum_class_type == 1
          "
        >
          <el-button
            style="float: left"
            size="small"
            @click="openSupplementTchPlan"
            >补课<i class="el-icon-question el-icon--right"></i
          ></el-button>
        </el-tooltip>

        <el-button size="small" @click="dialogFormVisible2 = false"
          >取 消</el-button
        >
        <el-button
          size="small"
          type="primary"
          @click="updateSign"
          :disabled="SignClassInfo.teachingPlanState == '未开课'"
          >提交签到信息</el-button
        >
      </div>
    </el-dialog>

    <!--临时调课-->
    <el-dialog width="80%" title="临时调课" :visible.sync="dialogFormVisible3">
      <el-row>
        <el-col :span="12"
          ><div>
            <span>班级名称:</span>
            <span style="margin-left: 20px">{{
              SignClassInfo.classInfo.name
            }}</span>
          </div></el-col
        >
        <el-col :span="12">
          <div>
            <span>上课时间:</span>
            <span style="margin-left: 20px"
              >{{ SignClassInfo.start_class_date }} -
              {{ SignClassInfo.end_class_date.slice(10, 20) }}</span
            >
          </div></el-col
        >
      </el-row>

      <div style="margin-top: 20px">
        <el-table
          size="small"
          :data="ClassStudents"
          style="width: 100%"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column
            align="center"
            prop="studentInfo.studentUserInfo.realname"
            label="姓名"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="studentInfo.name"
            label="平台账号"
          ></el-table-column>

          <el-table-column align="center" label="缺勤原因">
            <template slot-scope="scope">
              <span v-if="scope.row.stuTchPlanInfo.not_come_reason == '1'"
                >事假</span
              >
              <span v-else-if="scope.row.stuTchPlanInfo.not_come_reason == '2'"
                >病假</span
              >
              <span v-else-if="scope.row.stuTchPlanInfo.not_come_reason == '3'"
                >旷课</span
              >
            </template>
          </el-table-column>

          <el-table-column align="center" label="备注">
            <template slot-scope="scope">
              <span>{{ scope.row.stuTchPlanInfo.remark }}</span>
            </template>
          </el-table-column>
          <el-table-column align="center" label="操作" width="150">
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.stuTchPlanInfo.is_vaild"
                @click="GoChangePlan(scope.row)"
                size="mini"
                type="primary"
                >调课</el-button
              >

              <el-button
                v-else
                @click="CancelChangePlan(scope.row)"
                size="mini"
                type="primary"
                >取消调课</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-dialog>

    <el-dialog
      title="选择调入讲次"
      :visible.sync="ChangePlanDialogVisible"
      width="80%"
      top="10vh"
    >
      <div>
        <el-form
          size="small"
          :inline="true"
          ref="form"
          :model="changeplanform"
          label-width="100"
        >
          <el-form-item label="上课老师">
            <el-select
              v-model="changeplanform.leader"
              placeholder="请选择上课老师"
            >
              <el-option
                v-for="item in teacherList"
                :key="item.id"
                :label="item.realName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>

          <el-form-item label="上课时间">
            <el-date-picker
              v-model="changeplanform.date"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              placement="bottom-start"
            >
            </el-date-picker>
          </el-form-item>

          <el-form-item label="授课时段">
            <el-select
              v-model="changeplanform.type"
              multiple
              collapse-tags
              style="margin-left: 20px"
              placeholder="请选择"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item size="mini">
            <el-button type="primary" @click="SearchPlan">查询</el-button>
          </el-form-item>
        </el-form>
      </div>

      <div class="dialog-body">
        <el-table
          size="small"
          ref="classTable"
          :data="tchPlanList"
          tooltip-effect="dark"
          highlight-current-row
          :header-cell-style="{ background: '#f5f7fa' }"
          @current-change="handleSelectionChange"
        >
          <el-table-column
            align="center"
            prop="lessionInfo.title"
            label="讲次名称"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="classInfo.name"
            label="班级名称"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="lecturerName"
            label="上课老师"
          ></el-table-column>

          <el-table-column
            align="center"
            prop="stuTotalSignNum"
            label="学员数"
          ></el-table-column>

          <el-table-column align="center" label="上课时间">
            <template slot-scope="scope">
              <span
                >{{ scope.row.start_class_date }} -
                {{ scope.row.end_class_date.slice(10, 20) }}</span
              >
            </template>
          </el-table-column>
        </el-table>

        <div class="pagination-style">
          <el-pagination
            @size-change="handleSizeChange1"
            @current-change="handleCurrentChange1"
            :current-page="page_no1"
            :page-sizes="[10, 15, 20, 30, 40, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total1"
          >
          </el-pagination>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="ChangePlanDialogVisible = false"
          >取消</el-button
        >
        <el-button size="small" type="primary" @click="changeStuTchPlan"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!--添加学员-->
    <el-dialog
      title="选择学员"
      :visible.sync="dialogVisible1"
      width="80%"
      top="10vh"
    >
      <el-form :inline="true" size="mini">
        <el-form-item label="">
          <el-input
            style="width: 250px"
            v-model="form1.realname"
            placeholder="请输入学员姓名"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="search_student">查询</el-button>
        </el-form-item>
      </el-form>

      <div>
        <el-table
          size="mini"
          :data="Student_tableData"
          @selection-change="CurrentChange_Student"
          :header-cell-style="{ background: '#f5f7fa' }"
        >
          <el-table-column type="selection" width="55"> </el-table-column>

          <el-table-column fixed="left" width="150" align="center" label="姓名">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.realname }}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="name"
            label="账号"
          ></el-table-column>

          <el-table-column width="50" align="center" prop="sex" label="性别">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.sex }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="学校名称">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.school_name }}</span>
            </template>
          </el-table-column>
          <el-table-column width="150" align="center" label="在校年级">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.gradeStr }}</span>
            </template>
          </el-table-column>

          <el-table-column align="center" label="所在班级" width="200">
            <template slot-scope="scope">
              <div
                v-for="item in scope.row.curriculum_class_list"
                :key="item.id"
              >
                <span>{{ item.name }}</span> <br />
              </div>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="联系电话">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.parent_a }}</span>
              <span>{{ scope.row.studentUserInfo.parent_a_phone_num }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="家长微信">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.parent_b }}</span>
              <span>{{ scope.row.studentUserInfo.parent_b_phone_num }}</span>
            </template>
          </el-table-column>

          <el-table-column width="150" align="center" label="负责人">
            <template slot-scope="scope">
              <span>{{ scope.row.studentUserInfo.leaderName }}</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="normal_state"
            label="学员状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.normal_state == '1'">试听</span>
              <span v-else-if="scope.row.normal_state == '2'">在读</span>
              <span v-else-if="scope.row.normal_state == '3'">休学</span>
              <span v-else-if="scope.row.normal_state == '4'">已退学</span>
              <span v-else>未知</span>
            </template>
          </el-table-column>

          <el-table-column
            width="150"
            align="center"
            prop="created_time"
            label="录入时间"
          ></el-table-column>
        </el-table>
      </div>
      <div class="pagination-style">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="page_no2"
          :page-sizes="[10, 15, 20, 30, 40, 50, 100]"
          :page-size="10"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total2"
        >
        </el-pagination>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible1 = false">取消</el-button>
        <el-button size="small" type="primary" @click="addStuToTeachingPlan"
          >确定</el-button
        >
      </span>
    </el-dialog>

    <!--修改讲次信息-->
    <el-dialog
      width="660px"
      top="10vh"
      title="讲次信息"
      :visible.sync="dialogFormVisible7"
    >
      <el-form
        size="mini"
        :model="updateform"
        ref="form"
        label-width="100px"
        label-position="center"
      >
        <el-form-item label="讲次名称" required>
          <el-input
            disabled
            v-model="updateform.title"
            placeholder="请输入讲次"
            style="width: 500px"
          ></el-input>
        </el-form-item>

        <el-form-item label="上课老师" required>
          <el-select
            v-model="updateform.lecturer_id"
            style="width: 500px"
            :disabled="updateform.start_date"
          >
            <el-option
              :label="item.realName + ' ' + '(' + item.name + ')'"
              :value="item.id"
              v-for="(item, index) of teacherList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="上课日期" required>
          <el-date-picker
            type="date"
            placeholder="请选择课程开始时间"
            v-model="updateform.class_date"
            style="width: 500px"
            value-format="yyyy-MM-dd"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上课时段" required>
          <el-time-picker
            v-model="updateform.start_time"
            placeholder="选择开始时间"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
          至
          <el-time-picker
            v-model="updateform.end_time"
            placeholder="选择结束时间"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogFormVisible7 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="updateTeachingPlan"
          >修 改</el-button
        >
      </div>
    </el-dialog>

    <el-dialog title="补课信息" :visible.sync="dialogVisible2" width="500px">
      <el-form size="small" :model="updateform1" ref="form" label-width="100px">
        <el-form-item label="上课日期" required>
          <el-date-picker
            type="date"
            placeholder="请选择课程开始时间"
            v-model="updateform1.class_date"
            style="width: 300px"
            value-format="yyyy-MM-dd"
            placement="bottom-start"
          ></el-date-picker>
        </el-form-item>

        <el-form-item label="上课时段" required>
          <el-time-picker
            is-range
            v-model="updateform1.value"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围"
            value-format="HH:mm:ss"
          >
          </el-time-picker>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="dialogVisible2 = false"
          >取 消</el-button
        >
        <el-button size="small" type="primary" @click="addSupplementTchPlan"
          >确 认</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getTeachingPlanList,
  getTeachingPlanStuList,
  updateStuTeachingPlanSignInfo,
  addStuToTeachingPlan,
  deleteStuOfTeachingPlan,
  getStuListForChangeStuTchPlan,
  // getCampusTeacherList,
  changeStuTchPlan, //临时调课
  getTchPlanListForChangeStuTchPlan, //获得可调入讲次
  cancelChangeStuTchPlan, //取消调课
  getFormalStudentListForAddToTchPlan,
  getCampusAllCurriculumtList,
  updateTeachingPlan,
  updateTchPlanSignState,
  addSupplementTchPlan,
} from '@/api/educational.js'
import { api_eduCampusSelectTchListByCampus } from '@/api/javaApi'

import { dateFormat } from '@/config/_filter'

export default {
  name: 'teachplan',
  data() {
    return {
      moresearch: true, //搜索条件
      pickerOptions: {
        shortcuts: [
          {
            text: '未来一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '未来一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '未来三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              end.setTime(start.getTime() + 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
      //分页管理
      page_no: 1,
      page_size: 10,
      total: 0,

      page_no1: 1,
      page_size1: 10,
      total1: 0,
      //选择学员
      page_no2: 1,
      page_size2: 10,
      total2: 0,

      SignStudents: [], //签到学员信息
      current_teachplan_id: '', //当前教学计划ID
      ClassStudents: [], //班级学员列表
      ChangePlanDialogVisible: false,

      stuSignInfoList: [],
      checked: false,
      //签到班级信息
      SignClassInfo: {
        classInfo: { name: '' },
        start_class_date: '',
        end_class_date: '',
      },

      teachplan_form: {
        title: '', //讲次名称
        educational_institution_campus_id: '',
        classname: '', //班级名称
        week: [], //星期
        time: [], //时段 上下午 晚上
        latest: true,
        sign_state: '', //开课状态
        default_time: '', //默认时间
        date: [],
        lecturer_id: '', // 上课老师
      },
      school_list: [],
      teacherList: [], //所属校区的教师列表
      TeachPlanList: [], //教学计划列表

      weeklist: [
        { id: 1, name: '周一' },
        { id: 2, name: '周二' },
        { id: 3, name: '周三' },
        { id: 4, name: '周四' },
        { id: 5, name: '周五' },
        { id: 6, name: '周六' },
        { id: 0, name: '周日' },
      ],
      timelist: [
        {
          id: 1,
          name: '上午',
        },
        {
          id: 2,
          name: '下午',
        },
        {
          id: 3,
          name: '晚上',
        },
      ],
      statelist: [
        { id: 1, name: '已上课' },
        { id: 2, name: '未上课' },
      ],

      course_list: [],

      dialogVisible1: false, //教学计划添加学员
      chooseStudent_current: [], //选择的学员
      visible: false, //提示是否移除教学计划

      changeplanform: {
        type: ['1', '2', '3'],
        date: ['', ''],
      }, //调入讲次查询参数
      changeplaninfo: {}, //调课确认参数
      selected_plan: {}, //已选讲次

      dialogFormVisible2: false, //点名上课
      dialogFormVisible3: false, //临时调课
      dialogFormVisible7: false, //修改讲次信息

      updateform: {
        title: '',
        lecturer_id: '',
        educational_institution_campus_id: '',
        class_date: '',
        value: [],
        teaching_plan_id: '',
        start_time: '',
        end_time: '',
      },

      tableData: [], //讲次列表
      tchPlanList: [], //调入讲次列表

      activeName: 'first',

      //班级排课计划信息
      classname: '',

      options: [
        {
          value: '1',
          label: '上午',
        },
        {
          value: '2',
          label: '下午',
        },
        {
          value: '3',
          label: '晚上',
        },
      ],

      //添加学员相关
      form1: {}, //选择学员查询按钮
      Student_tableData: [],

      stu_tch_plan_type: '', //临调状态
      //大课表

      //签到学员列表
      signStus: [],
      allcost: false,
      allsign: false,

      //忽略排课冲突
      if_ignore_conflict: '0',

      //补课
      dialogVisible2: false,
      updateform1: {
        class_date: '',
        value: ['', ''],
      },
      if_ignore_conflict1: 0,
    }
  },

  watch: {
    '$store.state.user.selected_schools': {
      handler(newValue, oldValue) {
        console.log('校区监听')
        console.log(newValue)
        console.log(oldValue)
        if (newValue.length == 0) {
          this.$message.warning('目标校区不能为空')
          this.course_list = []
          this.teacherList = []
          this.teachplan_form.curriculum_id = ''
          this.teachplan_form.lecturer_id = ''
        } else if (newValue.length == 1) {
          this.getCampusAllCurriculumtList()
          this.getTeachingPlanList()
          this.getCampusTeacherList()
        } else {
          this.getTeachingPlanList()
          this.course_list = []
          this.teachplan_form.curriculum_id = ''
        }
      },
      deep: true,
    },
  },

  mounted() {
    if (this.$store.state.user.selected_schools.length == 0) {
      this.$message.warning('请选择校区')
      this.course_list = []
      this.teachplan_form.curriculum_id = ''
    } else if (this.$store.state.user.selected_schools.length == 1) {
      this.teachplan_form.default_time = dateFormat() //默认查今天往后的课程
      this.getCampusAllCurriculumtList()
      this.getTeachingPlanList()
      this.getCampusTeacherList()
    } else {
      this.teachplan_form.default_time = dateFormat() //默认查今天往后的课程
      this.getTeachingPlanList()
      this.course_list = []
      this.teachplan_form.curriculum_id = ''
    }
  },
  methods: {
    LatestCourse(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('最近课程')
      console.log(this.teachplan_form.latest)

      if (!this.teachplan_form.latest) {
        this.teachplan_form.default_time = dateFormat() //获得当前时间
      } else {
        this.teachplan_form.default_time = ''
      }
      this.page_no = 1
      this.getTeachingPlanList()
      console.log(this.teachplan_form.default_time)
    },

    //改变搜索条件
    ChangeSearchState() {
      this.moresearch = !this.moresearch
    },

    updateTeachingPlan() {
      console.log('更新讲次参数')
      console.log(this.updateform)

      if (!this.updateform.start_time) {
        this.$message.warning('请选择开始时间')
        return
      }

      if (!this.updateform.end_time) {
        this.$message.warning('请选择结束时间')
        return
      }

      updateTeachingPlan({
        lecturer_id: this.updateform.lecturer_id,
        teaching_plan_id: this.updateform.teaching_plan_id,
        class_date: this.updateform.class_date,
        start_class_date: this.updateform.start_time,
        end_class_date: this.updateform.end_time,
        title: this.updateform.title,
        classId: this.updateform.classId,
        if_ignore_conflict: this.if_ignore_conflict,
      }).then((res) => {
        console.log('更新课程讲次')
        console.log(res)
        if (res.is_update) {
          this.$message.success('修改成功')
          this.dialogFormVisible7 = false
          this.getTeachingPlanList()
        } else {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.if_ignore_conflict = '1'
              this.updateTeachingPlan()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消排课',
              })
              this.dialogFormVisible7 = false
            })
        }
      })
    },

    //更新讲次信息
    UpdatePlanInfo(row) {
      console.log('更新讲次信息11')
      console.log(row)

      this.if_ignore_conflict = '0'

      this.dialogFormVisible7 = true
      this.teachplan_form.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.title = row.lessionInfo.title
      this.updateform.educational_institution_campus_id =
        row.educational_institution_campus_id
      this.updateform.lecturer_id = row.lecturer_id
      this.updateform.class_date = row.class_date
      this.updateform.classId = row.classInfo.id
      this.updateform.teaching_plan_id = row.id

      var time0 = row.start_class_date.split(' ')[1]
      var time1 = row.end_class_date.split(' ')[1]
      this.updateform.start_time = time0
      this.updateform.end_time = time1

      this.getCampusTeacherList()
    },

    //向教学计划中添加学员
    addStuToTeachingPlan() {
      console.log('添加学员参数')
      console.log(this.current_teachplan_id)
      console.log(this.chooseStudent_current)

      addStuToTeachingPlan({
        teaching_plan_id: this.current_teachplan_id,
        studentIds: JSON.stringify(this.chooseStudent_current),
        stu_tch_plan_type: '2', //临调学员
      }).then((res) => {
        console.log('向教学计划中添加学员')
        console.log(res)
        if (res.is_update) {
          this.$message.success('添加学员成功')
          this.dialogVisible1 = false
        }
      })
    },
    //从教学计划中移除学员
    deleteStuOfTeachingPlan(id) {
      deleteStuOfTeachingPlan({
        teaching_plan_id: this.current_teachplan_id,
        studentId: id,
      }).then((res) => {
        console.log('将学员移除讲次')
        console.log(res)
        if (res.is_delete) {
          this.$message.success('移除学员成功')
          this.getTeachingPlanStuList(this.current_teachplan_id)
        }
      })
    },

    //点击学员调课按钮
    GoChangePlan(row) {
      console.log('点击学员调课按钮')
      console.log(row)
      this.ChangePlanDialogVisible = true
      this.changeplaninfo.student_user_id = row.student_user_id
      this.changeplaninfo.stu_tch_plan_id = row.stuTchPlanInfo.id
      this.getTchPlanListForChangeStuTchPlan()
    },

    CancelChangePlan(row) {
      console.log(row) //取消调课
      this.cancelChangeStuTchPlan(row)
    },

    //选择调入讲次
    handleSelectionChange(val) {
      console.log('选择的讲次')
      console.log(val)
      this.selected_plan = val
    },

    //更新学员签到信息
    handleSelectionChange1(val) {
      console.log('签到学员列表')
      console.log(val)
      this.signStus = val
    },

    //取消表格选中状态
    toggleSelection(rows) {
      if (rows) {
        rows.forEach((row) => {
          this.$refs.multipleTable.toggleRowSelection(row)
        })
      } else {
        this.$refs.multipleTable.clearSelection()
      }
    },

    //临时调课接口
    changeStuTchPlan() {
      console.log('调课参数')
      console.log('当前讲次ID')
      console.log(this.changeplaninfo.stu_tch_plan_id)
      console.log('调入讲次ID')
      console.log(this.selected_plan.id)

      changeStuTchPlan({
        change_stu_tch_plan_id: this.selected_plan.id, //调入讲次id
        stu_tch_plan_id: this.changeplaninfo.stu_tch_plan_id, //学生当前讲次id
        student_user_id: this.changeplaninfo.student_user_id, //学生id
      }).then((res) => {
        console.log('确认调课')
        console.log(res)
        if (res.is_change) {
          this.$message.success('调课成功')
          this.getStuListForChangeStuTchPlan()
          this.ChangePlanDialogVisible = false
        }
      })
    },

    //取消调课
    cancelChangeStuTchPlan(row) {
      cancelChangeStuTchPlan({
        change_stu_tch_plan_id: row.stuTchPlanInfo.change_stu_tch_plan_id, //调入讲次id
        stu_tch_plan_id: row.stuTchPlanInfo.id, //学生当前讲次id
        student_user_id: row.student_user_id, //学生id
      }).then((res) => {
        console.log('取消调课')
        console.log(res)
        if (res.is_cancel) {
          this.$message.success('取消成功')
          this.getStuListForChangeStuTchPlan()
        }
      })
    },

    // 具有科目权限及课程体系的老师
    getCampusTeacherList() {
      api_eduCampusSelectTchListByCampus({
        eduCampusIdList: this.$store.state.user.selected_schools,
      }).then((res) => {
        console.log('具有科目权限及课程体系的老师')
        console.log(res)
        this.teacherList = res //主讲老师
      })
    },

    //获取校区的排课信息
    getTeachingPlanList() {
      console.log('星期')
      console.log(this.teachplan_form.week)
      console.log(this.teachplan_form.date)
      console.log(this.teachplan_form.curriculum_id)
      console.log(this.teachplan_form.default_time)

      var start_date = ''
      var end_date = ''

      if (this.teachplan_form.default_time) {
        console.log('查询最近课程')
        start_date = this.teachplan_form.default_time
        end_date = ''
      } else {
        if (this.teachplan_form.date) {
          start_date = this.teachplan_form.date[0]
          end_date = this.teachplan_form.date[1]
          console.log('根据时间查询课程')
        } else {
          start_date = ''
          end_date = ''
          console.log('无时间查询课程')
        }
      }

      getTeachingPlanList({
        campusIds: JSON.stringify(this.$store.state.user.selected_schools),
        className: this.teachplan_form.classname, //班级名称
        curriculum_id: this.teachplan_form.curriculum_id, //课程体系ID
        start_date: start_date, // 开始时间

        end_date: end_date, // 结束时间
        quantum_state: JSON.stringify(this.teachplan_form.time),
        week_state: JSON.stringify(this.teachplan_form.week),
        sign_state: this.teachplan_form.sign_state,
        title: this.teachplan_form.title,
        lecturer_id: this.teachplan_form.lecturer_id,
        page_no: this.page_no,
        page_size: this.page_size,
      }).then((res) => {
        console.log('查询校区教学计划')
        console.log(res)
        this.TeachPlanList = res.teachingPlan
        this.total = res.total
      })
    },

    //获得调课页面用的教学计划列表
    getTchPlanListForChangeStuTchPlan() {
      console.log('查询可调入讲次参数')
      console.log(this.changeplanform)
      console.log(this.current_teachplan_id)
      console.log(this.teachplan_form.educational_institution_campus_id)
      console.log(this.changeplanform.date[0])
      console.log(this.changeplanform.date[1])

      getTchPlanListForChangeStuTchPlan({
        teaching_plan_id: this.current_teachplan_id,
        lecturer_id: this.changeplanform.leader,
        educational_institution_campus_id: this.$store.state.user
          .selected_schools[0],
        start_date: this.changeplanform.date[0],
        end_date: this.changeplanform.date[1],
        quantum_state: JSON.stringify(this.changeplanform.type),
        page_no: this.page_no1,
        page_size: this.page_size1,
      }).then((res) => {
        console.log('获得调课页面用的教学计划列表')
        console.log(res)
        this.tchPlanList = res.tchPlanList
        this.total1 = res.total
      })
    },

    getCampusAllCurriculumtList() {
      getCampusAllCurriculumtList({
        campusId: this.$store.state.user.selected_schools[0],
      }).then((res) => {
        console.log('获得分校所有课程体系')
        console.log(res)

        this.course_list = res.campusCurriculumList
      })
    },

    //生成补课计划
    openSupplementTchPlan() {
      if (this.signStus.length == 0) {
        this.$message.warning('请勾选补课学员')
        return
      }
      this.dialogVisible2 = true
    },

    //生成补课计划
    addSupplementTchPlan() {
      console.log(this.signStus)
      this.dialogVisible2 = false
      var stuIds = []
      for (let k = 0; k < this.signStus.length; k++) {
        stuIds.push(this.signStus[k].student_user_id)
      }
      if (!this.updateform1.class_date) {
        this.$message.warning('请选择上课日期')
        return
      }
      if (!this.updateform1.value) {
        this.$message.warning('请选择上课时段')
        return
      }
      console.log('补课提交的参数')
      console.log(this.current_teachplan_id)
      console.log(stuIds)
      console.log(this.updateform1)
      console.log(this.if_ignore_conflict1)
      addSupplementTchPlan({
        originalTchPlanId: this.current_teachplan_id,
        stuIds: JSON.stringify(stuIds),
        supplement_tchplan_class_date: this.updateform1.class_date,
        supplement_tchplan_start_class_date: this.updateform1.value[0],
        supplement_tchplan_end_class_date: this.updateform1.value[1],
        if_ignore_conflict: this.if_ignore_conflict1,
      }).then((res) => {
        console.log('补课计划返回')
        console.log(res)
        if (res.is_create) {
          this.$message.success('补课计划安排成功')
          this.dialogVisible2 = false
        } else {
          this.$confirm(res.msg, '提示', {
            confirmButtonText: '忽略冲突',
            cancelButtonText: '取消排课',
            type: 'warning',
          })
            .then(() => {
              this.if_ignore_conflict1 = '1'
              this.addSupplementTchPlan()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '取消排课',
              })
              this.dialogVisible2 = true
            })
        }
      })
    },

    search() {
      this.getTeachingPlanList()
    },

    search_student() {
      this.getFormalStudentListForAddToTchPlan()
    },

    //页码管理
    handleClick() {},

    handleSizeChange(val) {
      this.page_size = val
      this.getTeachingPlanList()
    },
    handleCurrentChange(val) {
      this.page_no = val
      this.getTeachingPlanList()
    },

    handleSizeChange1(val) {
      this.page_size1 = val
      //this.getTeachingPlanList();
    },
    handleCurrentChange1(val) {
      this.page_no1 = val
      //this.getTeachingPlanList();
    },

    handleSizeChange2(val) {
      this.page_size2 = val
      //this.getTeachingPlanList();
    },
    handleCurrentChange2(val) {
      this.page_no2 = val
      //this.getTeachingPlanList();
    },

    editStudent() {},

    GoSign(row) {
      this.allsign = false
      this.allcost = false

      this.SignStudents = []
      this.dialogFormVisible2 = true
      this.SignClassInfo = row
      this.current_teachplan_id = row.id
      console.log(row)
      this.getTeachingPlanStuList(row.id)
    },

    //更新教学计划的签到状态
    updateTchPlanSignState(id) {
      console.log('更新上课状态')
      console.log(id)

      updateTchPlanSignState({
        teaching_plan_id: id,
      }).then((res) => {
        console.log('更新教学计划的签到状态')
        console.log(res)
      })
    },

    //全部标记为出勤
    SetAllSign(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('全部标记为出勤')
      console.log(this.allsign)
      console.log(this.stuSignInfoList)

      if (!this.allsign) {
        console.log('批量全勤')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].sign_state = 1
              }
            }
          }
        }
      } else {
        console.log('批量取消全勤')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].sign_state = null
              }
            }
          }
        }
      }
    },

    //全部标记为计费
    SetAllCost(e) {
      if (e.target.tagName === 'INPUT') return // 因为原生click事件会执行两次，第一次在label标签上，第二次在input标签上，故此处理

      console.log('全部标记为计费')
      console.log(e)
      console.log(this.allcost)
      console.log(this.stuSignInfoList)

      if (!this.allcost) {
        console.log('批量计费')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].cost_state = 1
              }
            }
          }
        }
      } else {
        console.log('批量取消计费')
        if (this.signStus.length == 0) {
          this.$message.warning('请选择学员')
          return
        } else {
          for (let j = 0; j < this.SignStudents.length; j++) {
            for (let k = 0; k < this.signStus.length; k++) {
              if (this.SignStudents[j].id == this.signStus[k].id) {
                this.SignStudents[j].cost_state = null
              }
            }
          }
        }
      }
    },

    //学员临时调课
    StudentChangePlan(row) {
      this.SignStudents = []
      this.dialogFormVisible3 = true
      this.SignClassInfo = row
      this.current_teachplan_id = row.id
      this.getStuListForChangeStuTchPlan()
      this.getCampusTeacherList() //获得校区教师列表
    },

    AddStudentToPlan(row) {
      console.log('添加学员')
      console.log(row)
      this.current_teachplan_id = row.id
      this.dialogVisible1 = true
      this.teachplan_form.educational_institution_campus_id =
        row.educational_institution_campus_id
      //TODO 查询所有学员
      this.getFormalStudentListForAddToTchPlan()
    },

    //查询学员调课页面学生列表
    getStuListForChangeStuTchPlan() {
      console.log('当前教学计划ID')
      console.log(this.current_teachplan_id)
      getStuListForChangeStuTchPlan({
        teaching_plan_id: this.current_teachplan_id,
      }).then((res) => {
        console.log('查询学员调课页面学生列表')
        console.log(res)
        this.ClassStudents = res.classStuList
      })
    },

    //获得教学计划对应的学生计划列表
    getTeachingPlanStuList(id) {
      getTeachingPlanStuList({
        teachingPlanId: id,
      }).then((res) => {
        console.log('获得教学计划对应的学生计划列表')
        console.log(res)

        this.SignStudents = res.stuPlanList
      })
    },

    //更新教学计划签到信息
    updateSign() {
      console.log('签到学员信息')
      console.log(this.signStus)
      console.log('上课状态')
      console.log(this.SignClassInfo)

      if (this.SignClassInfo.sign_state == '2') {
        this.updateTchPlanSignState(this.current_teachplan_id)
      }

      if (this.signStus.length == 0) {
        this.$message.warning('选勾选签到学员')
        return
      }

      for (let k = 0; k < this.signStus.length; k++) {
        if (!this.signStus[k].sign_state) {
          this.$message.warning(
            this.signStus[k].studentInfo.studentUserInfo.realname +
              ',出勤状态不能为空'
          )
          this.toggleSelection(this.signStus.slice(k))
          return
        }

        if (!this.signStus[k].cost_state) {
          this.$message.warning(
            this.signStus[k].studentInfo.studentUserInfo.realname +
              ',计费状态不能为空'
          )
          this.toggleSelection(this.signStus.slice(k))
          return
        }
      }

      this.stuSignInfoList = []

      for (let k = 0; k < this.signStus.length; k++) {
        const sign_stu = {
          stuId: this.signStus[k].student_user_id,
          cost_state: this.signStus[k].cost_state,
          sign_state: this.signStus[k].sign_state,
          not_come_reason: this.signStus[k].not_come_reason,
          remark: this.signStus[k].remark,
        }
        this.stuSignInfoList.push(sign_stu)
      }

      console.log('转化后的学员信息')
      console.log(this.stuSignInfoList)
      this.updateStuTeachingPlanSignInfo()
    },

    //更新学员签到信息
    updateStuTeachingPlanSignInfo() {
      updateStuTeachingPlanSignInfo({
        stuSignInfoList: JSON.stringify(this.stuSignInfoList),
        teaching_plan_id: this.current_teachplan_id,
      }).then((res) => {
        console.log('更新学员签到信息')
        console.log(res)
        if (res.is_update) {
          this.$message.success('签到成功')
          this.SignStudents = []
          this.getTeachingPlanStuList(this.current_teachplan_id)
        }
      })
    },

    SearchPlan() {
      console.log('查询调入讲次')
      this.getTchPlanListForChangeStuTchPlan()
    },

    CurrentChange_Student(val) {
      console.log('选择了学员')
      console.log(val)
      this.chooseStudent_current = []

      for (let k = 0; k < val.length; k++) {
        this.chooseStudent_current.push(val[k].id)
      }
    },

    //查询所有正式学员
    getFormalStudentListForAddToTchPlan() {
      console.log('添加学员，所属校区')
      console.log(this.teachplan_form.educational_institution_campus_id)

      getFormalStudentListForAddToTchPlan({
        realname: this.form1.realname,
        leader: this.form1.leader,
        teaching_plan_id: this.current_teachplan_id,
        phone_a_num: this.form1.phone_a_num,
        normal_state: this.form1.normal_state,
        educational_institution_campus_id: this.teachplan_form
          .educational_institution_campus_id,
        page_no: this.page_no2,
        page_size: this.page_size2,
      }).then((res) => {
        console.log('查询所有正式学员')
        console.log(res)
        this.Student_tableData = res.studentList
        this.total2 = res.total
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.listen-test-management {
  background-color: #fff;
  margin: 10px;
  border-radius: 5px;
  section {
    padding-top: 10px;
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 20px;
  }

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
    font-size: 12px;
    padding-right: 5px;
  }
  .el-icon-arrow-down {
    font-size: 12px;
  }
}
</style>
